import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Ticket } from 'api/ticketing.api';

@Component({
    selector: 'ce-ticket-list-small',
    templateUrl: './ticket-list-small.component.html',
    styleUrls: ['./ticket-list-small.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketListSmallComponent {
    @Input() stationId: string;
    @Input() tickets: Ticket[];

    constructor(private router: Router) {}

    openTicket(ticket: Ticket) {
        this.router.navigate(['', { outlets: { d: ['notes', this.stationId, ticket.ticketId] } }]);
    }
}
